var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "logo-facebook",
    transform: "translate(252 -70)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_white",
    "data-name": "Ellipse white",
    cx: 15,
    cy: 15,
    r: 15,
    transform: "translate(-252 70)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_grey",
    "data-name": "Ellipse grey",
    cx: 10,
    cy: 10,
    r: 10,
    transform: "translate(-247 75)",
    fill: "#e3e3e3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_001-facebook",
    "data-name": "001-facebook",
    d: "M20,10A10,10,0,1,0,10,20c.059,0,.117,0,.176,0V12.215H8.027v-2.5h2.148V7.867a3.009,3.009,0,0,1,3.211-3.3,17.452,17.452,0,0,1,1.926.1V6.9H14c-1.035,0-1.238.492-1.238,1.215V9.707h2.48l-.324,2.5H12.762v7.4A10,10,0,0,0,20,10Z",
    transform: "translate(-247 75)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.96f532189b8cbc1f6503ec63536a1154.svg";
export { ForwardRef as ReactComponent };